// English UI labels — the fully-populated base.
// Course content (modules, SKUs, quizzes) lives in src/content, not here.
// This file is only the app chrome: navigation, buttons, state messages.
export default {
  app: {
    name: 'NON Academy',
    tagline: 'Trade up, not down.',
  },
  nav: {
    back: 'Back',
    home: 'Home',
    learn: 'Learn',
    reference: 'Quick reference',
    cards: 'Cards',
    language: 'Language',
  },
  role: {
    title: 'Who are you here as?',
    welcomeTitle: 'Welcome to NON Academy',
    intro: 'Choose your track. You can change it later. The product knowledge is shared; the skills are built for your role.',
    rep: 'NON Sales Rep',
    repBlurb: 'Win the listing. Sell into venues and distributors.',
    repGives: [
      'Read a list and win the placement',
      'Handle price and fridge-space objections',
      'Pitch and run reorders with confidence',
      'Win rewards as you complete',
    ],
    venue: 'Venue Staff',
    venueBlurb: 'Sommelier, floor, bar. Recommend NON with confidence.',
    venueGives: [
      'Recommend the right SKU for any dish',
      'Run the pour, temperature and glassware ritual',
      'Turn a sceptical guest into a sale',
      'Make more in tips with confident service',
      'Win rewards as you complete',
    ],
    shared: 'Shared core for both roles',
    continueAs: "Let's go",
    pickToStart: 'Choose a track to start',
    change: 'Change role',
  },
  topbar: {
    label: 'Your progress',
    level: 'Lvl {{level}}',
    streak: 'day streak',
    streakHint: 'Come back tomorrow to keep your streak alive.',
    complete: 'complete',
  },
  home: {
    welcome: 'Welcome back',
    resume: 'Resume',
    start: 'Start',
    review: 'Review',
    sharedCore: 'Foundations',
    repTrack: 'In the field',
    venueTrack: 'On the floor',
    certification: 'Certification',
    progress: '{{done}} of {{total}} modules complete',
    certifyVenue: 'NON Certified Sommelier',
    certifyRep: 'NON Rep Accreditation',
    locked: 'Complete the modules to unlock',
  },
  module: {
    objectives: 'What you will be able to do',
    segments: 'Segments',
    minutes: '{{count}} min',
    practical: 'Practical task',
    quizCta: 'Take the knowledge check',
    nextSegment: 'Next',
    prevSegment: 'Previous',
    markComplete: 'Mark complete',
    completed: 'Completed',
    segmentOf: '{{current}} of {{total}}',
    preCheck: 'Pre-check',
    preCheckTitle: 'Already know this?',
    preCheckBody: 'Take the one-minute pre-check and skip ahead if you ace it.',
    skipToQuiz: 'Skip to the knowledge check',
    startLearning: 'Start the module',
    practise: 'Practise with flashcards',
    recall: 'Quick recall',
    recallTitle: 'Warm up: recall the six',
    recallBody: 'Answer {{count}} quick questions on the SKUs before you start.',
    recallContinue: 'Into the module',
    worked: 'Worked example',
    whyItWorks: 'Why it works',
    required: 'Required',
    flashRound: 'Run a flashcard round',
    flashFirst: 'Complete the flashcard round first',
    attest: 'I have done this practical task',
    signOffNote: 'Optional: a manager or trainer can sign off.',
    signOffName: 'Manager or trainer name',
    discuss: 'Discuss with your manager',
  },
  quiz: {
    title: 'Knowledge check',
    intro: 'A few questions to confirm it landed. You can retake it.',
    question: 'Question {{current}} of {{total}}',
    submit: 'Submit answer',
    next: 'Next question',
    correct: 'Correct',
    incorrect: 'Not quite',
    partial: 'Close: {{earned}} of {{possible}}',
    yourScore: 'You scored {{score}}%',
    pass: 'Passed',
    fail: 'Keep going',
    passThreshold: 'Pass mark is {{threshold}}%',
    retake: 'Retake',
    backToModule: 'Back to module',
    finish: 'Finish',
  },
  flash: {
    title: 'Flashcards',
    scenario: 'The moment',
    tapReveal: 'Tap to reveal',
    tapBack: 'Tap to flip back',
    gotIt: 'Got it',
    review: 'Review again',
    doneTitle: 'Deck complete',
    doneBody: 'You worked through {{count}} cards. Come back to keep it sharp.',
    again: 'Run the deck again',
  },
  celebrate: {
    complete: 'Complete',
    continue: 'Continue',
    viewCard: 'Get your card',
    levelUp: 'New level reached: {{level}}',
  },
  signup: {
    eyebrow: 'Almost there',
    title: 'Save your certification',
    intro: 'Add your details to claim your certificate, get on the leaderboard, and keep your progress across devices.',
    name: 'Your name',
    email: 'Email',
    venue: 'Venue',
    market: 'Market',
    consent: 'I agree my training progress can be shared with my venue manager.',
    consentError: 'Please agree so your manager can see your progress.',
    emailError: 'Enter a valid email.',
    emailHint: 'Use a work or personal email, whichever you check.',
    cta: 'Claim my certificate',
    privacy: 'We use your email to send your certificate and track your progress. Your manager sees only your venue team.',
  },
  diagram: {
    glass: 'Wine glass',
    chilled: 'Serve chilled',
    pour: 'Pour to a third',
    light: 'Light and bright',
    structured: 'Full and structured',
  },
  team: {
    title: 'Team',
    card: 'Your venue',
    noTeam: 'Your team',
    intro: 'Track your progress against your venue.',
    yourCompletion: 'Your completion',
    modulesDone: '{{done}} of {{total}} modules complete',
    teamTotal: 'Team total',
    teamTotalPending: 'Team-wide completion appears once your venue is connected.',
  },
  reference: {
    title: 'Quick reference',
    intro: 'On-shift cheat sheets. Glassware, serve temperature, pairings. Readable offline.',
    glassware: 'Glassware',
    serveTemp: 'Serve temperature',
    pairing: 'Pairings',
    tasting: 'Tasting notes',
    format: 'Format',
    allSkus: 'The six SKUs',
    lockedTitle: 'Unlocks after certification',
    lockedBody: 'Earn your certification to pin the quick-reference cards for on-shift use.',
  },
  cert: {
    locked: 'Locked',
    unlocked: 'Certified',
    earnedOn: 'Earned {{date}}',
    earnedLede: 'You are certified. Share your card, then pin the quick reference for your shifts.',
    badgeSommelier: 'NON Certified Sommelier',
    badgeRep: 'NON Accredited Rep',
    requirements: 'Complete these first',
    requirementModule: 'Pass: {{title}}',
    readyTitle: 'You are ready',
    readyBody: 'Every module is complete. Pass the final exam to certify.',
    startExam: 'Start the final exam',
    examTitle: 'Final exam',
    claim: 'Claim certification',
    retakeExam: 'Retake the exam',
    backHome: 'Back to home',
    nameLabel: 'Name on your card',
    namePlaceholder: 'Your name',
    square: 'Square',
    landscape: 'Wide',
    share: 'Share',
    download: 'Download',
    shareText: 'I just earned my {{badge}} with NON Academy.',
    sharedFallback: 'Saved to your device. Share it from there.',
    rewardTitle: 'Your reward',
    rewardBody: 'Certified staff are entered into the current NON reward.',
  },
  common: {
    placeholderNote: 'Draft copy. Replace with approved content.',
    untranslated: 'This language is not translated yet. Showing English. Flagged for translation.',
    of: 'of',
  },
}
